<template>
  <div style="overflow: auto;">
    <!-- <div class="mb-3 caption strong" v-if="!isPayrollQueue && !isUserPayroll">
      <span v-if="totalHours">Total Hours: {{totalHours}} | </span><span v-if="totalPayroll">Total Payroll: ${{totalPayroll}} | </span><span v-if="totalBilling">Total Billing: ${{totalBilling}} | </span><span v-if="totalProfit">Net Profit: ${{totalProfit}}</span>
    </div> -->
	<vue-good-table
    @on-selected-rows-change="selectionChanged"
    :columns="columns"
    :rows="eventAssignments"
    styleClass="vgt-table bordered condensed"
    :pagination-options="{
      enabled: true,
      mode: 'records',
      perPage: 50,
    }"
    :select-options="{
      enabled: true,
      selectionText: 'rows selected',
      clearSelectionText: 'clear',
      selectOnCheckboxOnly: true,
    }"
    :search-options="{
      enabled: true,
      placeholder: 'Search this table',
    }"
    :sort-options="{
      enabled: true,
      multipleColumns: true,
      initialSortBy: [
        {field: 'date', type: 'desc'},
        {field: 'firstName', type: 'asc'},
      ],
    }"
  >
  	<div slot="selected-row-actions">

      <button class="btn btn__small btn__dark mr-4" @click="exportReport()">
        Export <i class="fa-regular fa-arrow-up-right-from-square ml-2"></i>
        <transition name="fade">
          <span class="ml-2" v-if="performingRequest2">
          <i class="fa fa-spinner fa-spin"></i>
          </span>
        </transition>
      </button>

      <button class="btn btn__small btn__dark" @click="payBatch()" v-if="!isPaidAssignments">
        Pay Batch <i class="fa-solid fa-square-dollar ml-2"></i>
        <transition name="fade">
          <span class="ml-2" v-if="performingRequest">
          <i class="fa fa-spinner fa-spin"></i>
          </span>
        </transition>
      </button>
    </div>
    <template slot="table-row" slot-scope="props">

      <span v-if="props.column.field == 'delete' && !isPaidAssignments">
        <button v-if="!props.row.hidden" class="btn btn__dark btn__small ml-2 mr-2" @click="removeEntry(props.row)">
          hide
        </button>
        <button v-if="props.row.hidden" class="btn btn__primary btn__small ml-2 mr-2" @click="showEntry(props.row)">
          show
        </button>
      </span>

      <span v-else-if="props.column.field == 'regRate'">
        <input type="number" v-model.trim="props.row.regRate" id="regRate" @change="onEditRegRate(props.row)" :readonly="props.row.removed" :class="{ muted: props.row.removed }"  />
      </span>
      <span v-else-if="props.column.field == 'dayRate'">
        <input type="text" v-model.trim="props.row.dayRate" id="dayRate" @change="onEditDayRate(props.row)" :readonly="props.row.removed" :class="{ muted: props.row.removed }" />
      </span>
      <span v-else-if="props.column.field == 'firstName'">
        <input type="text" v-model.trim="props.row.firstName" id="firstName" readonly :class="{ muted: props.row.removed }" />
      </span>
      <span v-else-if="props.column.field == 'lastName'">
        <input type="text" v-model.trim="props.row.lastName" id="lastName" readonly :class="{ muted: props.row.removed }" />
      </span>

      <span v-else-if="props.column.field == 'note'">
        <button :disabled="isPaidAssignments" v-show="!props.row.note" class="btn btn__flat btn__icon" @click="showNote(props.row)" v-tooltip="'Leave a note'"><i class="far fa-sticky-note ml-3 mr-3" style="opacity:0.5;"></i></button>
        <button :disabled="isPaidAssignments" v-show="props.row.note" class="btn btn__flat btn__icon" @click="showNote(props.row)" v-tooltip="'Leave a note'"><i class="far fa-sticky-note ml-3 mr-3" style="color:blue"></i></button>
        <transition name="modal">
          <div v-if="activeItem == props.row">
            <TimesheetNote :item="props.row" @close="closeNote(props.row)" />
          </div>
        </transition>
      </span>



      <span v-else-if="props.column.field == 'inTime'" style="display: flex;">
        <input type="time" :disabled="isPaidAssignments" v-model.trim="props.row.inTime" id="in" @blur="onEditIn(props.row)" :class="{ muted: props.row.removed }" />
        <button :disabled="isPaidAssignments" v-if="props.row.inTime" class="btn btn__icon ml-3" @click="removeIn(props.row)"><i class="fa-solid fa-xmark danger ml-2 mr-2"></i></button>
      </span>

      <span v-else-if="props.column.field == 'outTime'" style="display: flex;">
        <input :disabled="isPaidAssignments" type="time" v-model.trim="props.row.outTime" id="in" @blur="onEditOut(props.row)" :class="{ muted: props.row.removed }" />
        <button :disabled="isPaidAssignments" v-if="props.row.outTime" class="btn btn__icon ml-3" @click="removeOut(props.row)"><i class="fa-solid fa-xmark danger ml-2 mr-2"></i></button>
      </span>

      <span v-else-if="props.column.field == 'date'">
        <span v-if="props.row.date" :class="{ muted: props.row.removed }">{{props.row.date}}</span>
        <!-- <span v-if="props.row.date && isPaidAssignments && props.row.returned && props.row.returned.effectiveDate">{{props.row.returned.effectiveDate}}</span> -->
      </span>

      <span v-else-if="props.column.field == 'position' && !isPaidAssignments && !isPayrollQueue && !isUserPayroll" :class="{ muted: props.row.removed }">
        <v-select
          :disabled="isPaidAssignments"
          label="title" 
          :options="props.row.eventInfo.jobs"
          v-model="props.row.position"
          @input="onEditPosition(props.row)"
          >
        </v-select>
      </span>

      <span v-else-if="props.column.field == 'position' && (isPaidAssignments || isPayrollQueue || isUserPayroll)" :class="{ muted: props.row.removed }">
        <span v-if="props.row.position">{{props.row.position}}</span>
      </span>

      <span v-else-if="props.column.field == 'confirmed'" :class="{ muted: props.row.removed }">
        <span v-if="props.row.confirmed">{{props.row.confirmed}}</span>
      </span>

      <span v-else-if="props.column.field == 'breakTime'">
        <input :disabled="isPaidAssignments" type="number" v-model.trim="props.row.breakTime" id="breakTime" @blur="onEditBreakTime(props.row)" :class="{ muted: props.row.removed }" />
      </span>

      <span v-else-if="props.column.field == 'totalHours'">
        <input :disabled="isPaidAssignments" type="number" v-model.trim="props.row.totalHours" id="totalHours" @blur="onEditTotalHours(props.row)" :class="{ muted: props.row.removed }" />
        <!-- <button class="btn btn__small btn__icon" @click="onEditInOut(props.row)"><i class="fa-regular fa-arrows-rotate"></i></button> -->
      </span>

      <span v-else-if="props.column.field == 'regHours'">
        <input :disabled="isPaidAssignments" type="number" v-model.trim="props.row.regHours" id="regHours" @blur="onManEditRegHours(props.row)" :class="{ muted: props.row.removed }"/>
      </span>
      <span v-else-if="props.column.field == 'minHours'">
        <input :disabled="isPaidAssignments" type="number" v-model.trim="props.row.minHours" id="minHours" @change="onEditMinHours(props.row)" :class="{ muted: props.row.removed }" />
      </span>
      <span v-else-if="props.column.field == 'otHours'">
        <input :disabled="isPaidAssignments" type="number" v-model.trim="props.row.otHours" id="otHours" @change="onEditotHours(props.row)" :class="{ muted: props.row.removed }"/>
      </span>
      <span v-else-if="props.column.field == 'ot2Hours'">
        <input :disabled="isPaidAssignments" type="number" v-model.trim="props.row.ot2Hours" id="ot2Hours" @change="onEditot2Hours(props.row)" :class="{ muted: props.row.removed }"/>
      </span>
      <span v-else-if="props.column.field == 'mbp'">
        <input :disabled="isPaidAssignments" type="number" v-model.trim="props.row.mbp" id="mbp" @change="onEditMBP(props.row)" :class="{ muted: props.row.removed }"/>
      </span>
      <span v-else-if="props.column.field == 'tips'">
        <input :disabled="isPaidAssignments" type="number" v-model.trim="props.row.tips" id="tips" @change="onEditTips(props.row)" :class="{ muted: props.row.removed }" />
      </span>
      <!-- <span v-else-if="props.column.field == 'state'">
        <input type="text" v-model.trim="props.row.state" placeholder="CA" id="state" @blur="onSheetEditable(props.row)" />
      </span> -->
      <span v-else-if="props.column.field == 'status'" :class="{ muted: props.row.removed }">
        <v-select
          label="status" 
          :options="statuses"
          v-model="props.row.status"
          @input="onUpdateStatus(props.row)"
          :disabled="isPaidAssignments"
          :clearable=true
          >
        </v-select>
      </span>
      <span v-else-if="props.column.field == 'paystatus'" :class="{ muted: props.row.removed }">
        <v-select
          label="status" 
          :options="paystatuses"
          v-model="props.row.paystatus"
          @input="onUpdatePay(props.row)"
          :disabled="isPaidAssignments"
          :clearable=true
          >
        </v-select>
      </span>
      


      


      
      <span v-else-if="props.column.field == 'link' && props.row && props.row.userId" :class="{ muted: props.row.removed }">
<!--         <router-link v-if="props.row.realId" :to="`/users/` + props.row.realId">
          <i class="fas fa-external-link ml-3 mr-3"></i>
        </router-link> -->
        <router-link :to="`/users/` + props.row.userId">
          <i class="fas fa-external-link ml-3 mr-3"></i>
        </router-link>
      </span>

      <span v-else-if="props.column.field == 'onboardStatus'&& (isPaidAssignments || isPayrollQueue || isUserPayroll)">
        <div v-if="(!props.row.workerType || props.row.workerType == 'Contractors')" :class="{ muted: props.row.removed }">

            <span v-if="(props.row.evereeOnboardingComplete && !isPaidAssignments)">
              <button class="btn btn__small btn__flat">Contractor<i class="fa-solid fa-check ml-2"></i></button>
            </span>
            <span v-if="(!props.row.evereeOnboardingComplete && !isPaidAssignments)">
              <button class="btn btn__small btn__flat">In Process<i class="fas fa-exclamation-triangle ml-2 danger"></i></button>
            </span>

          <!-- <span v-for="(u, index)  in filteredInfo(props.row)" class="flex" :key="index">
            <span v-if="(u.workerId && u.evereeOnboardingComplete)">
              <button class="btn btn__small btn__flat">Contractor<i class="fa-solid fa-check ml-2"></i></button>
            </span>
            <span v-if="(u.workerId && !u.evereeOnboardingComplete)">
              <button class="btn btn__small btn__flat">In Process<i class="fas fa-exclamation-triangle ml-2 danger"></i></button>
            </span>
          </span> -->
        </div>
        <div v-if="props.row.workerType && props.row.workerType == 'Employees'"  :class="{ muted: props.row.removed }">

            <span v-if="(props.row.employeeId && props.row.employeeOnboardingComplete)">
              <button class="btn btn__small btn__flat">Employee<i class="fa-solid fa-check ml-2"></i></button>
    
            <!-- <span v-if="(u.empoyeeId && u.lifecycleStatus == 'ONBOARDING')">
              <button class="btn btn__small btn__flat">In Process<i class="fas fa-exclamation-triangle ml-2 warning"></i></button>
            </span> -->
            <span v-if="(props.row.employeeId && !props.row.employeeOnboardingComplete)">
              <button class="btn btn__small btn__flat">Not Started<i class="fas fa-exclamation-triangle ml-2 danger"></i></button>
            </span>
          </span>
        </div>
      </span>

      <span v-else-if="props.column.field == 'onboardStatus' && !isPaidAssignments && !isPayrollQueue && !isUserPayroll" :class="{ muted: props.row.removed }">
        <div v-if="(!props.row.workerType || props.row.workerType == 'Contractors')">
          <span v-if="(props.row.workerId && props.row.evereeOnboardingComplete)">
              <button class="btn btn__small btn__flat">Contractor<i class="fa-solid fa-check ml-2"></i></button>
            </span>
            <span v-if="(props.row.workerId && !props.row.evereeOnboardingComplete)">
              <button class="btn btn__small btn__flat">In Process<i class="fas fa-exclamation-triangle ml-2 danger"></i></button>
            </span>
          <!-- <span v-for="(u, index)  in filteredInfo(props.row)" class="flex" :key="index">
            <span v-if="(u.workerId && u.evereeOnboardingComplete)">
              <button class="btn btn__small btn__flat">Contractor<i class="fa-solid fa-check ml-2"></i></button>
            </span>
            <span v-if="(u.workerId && !u.evereeOnboardingComplete)">
              <button class="btn btn__small btn__flat">In Process<i class="fas fa-exclamation-triangle ml-2 danger"></i></button>
            </span>
          </span> -->
        </div>
        <div v-if="props.row.workerType && props.row.workerType == 'Employees'" :class="{ muted: props.row.removed }">

            <span v-if="(props.row.employeeId && props.row.employeeOnboardingComplete)">
              <button class="btn btn__small btn__flat">Employee<i class="fa-solid fa-check ml-2"></i></button>
            </span>
            <!-- <span v-if="(u.empoyeeId && u.lifecycleStatus == 'ONBOARDING')">
              <button class="btn btn__small btn__flat">In Process<i class="fas fa-exclamation-triangle ml-2 warning"></i></button>
            </span> -->
            <span v-if="(props.row.employeeId && !props.row.employeeOnboardingComplete)">
              <button class="btn btn__small btn__flat">Not Started<i class="fas fa-exclamation-triangle ml-2 danger"></i></button>
            </span>
   
        </div>
      </span>


      <span v-else-if="props.column.field == 'payTotal'" class="flex">
        
        <input v-if="props.row.payTotal" type="text" v-model.trim="props.row.payTotal" id="payTotal" readonly :class="{ muted: props.row.removed }" />
        <button class="btn btn__small btn__icon" @click="onUpdateTotal(props.row)">
          <i class="fa-regular fa-arrows-rotate fa-spin" v-if="props.row.totalUpdating"></i>
          <i class="fa-regular fa-arrows-rotate" v-if="!props.row.totalUpdating"></i></button>
      </span>


      <span v-else-if="props.column.field == 'save' && !isPaidAssignments && !isPayrollQueue && !isUserPayroll" :class="{ muted: props.row.removed }">
        <div v-if="(!props.row.workerType || props.row.workerType == 'Contractors')">
            <span v-if="(props.row.evereeOnboardingComplete) && (!props.row.paystatus || props.row.paystatus != 'paid')">
              <button :disabled="(!props.row.payTotal || props.row.payTotal == null)" class="btn btn__primary btn__small ml-2 mr-2" @click="sendPayment(props.row)">
              Send Payment
              </button>
            </span>
            <span v-if="(!props.row.evereeOnboardingComplete) && (!props.row.paystatus || props.row.paystatus != 'paid')">
              <button class="btn btn__outlined btn__small ml-2 mr-2" @click="contCheck(props)">
                Sync 
                <span class="ml-2" v-if="!props.row.checking">
                  <i class="fa fa-rotate"></i>
                </span>
                <transition name="fade">
                  <span class="ml-2" v-if="props.row.checking">
                  <i class="fa fa-spinner fa-spin"></i>
                  </span>
                </transition>
              </button>
              <!-- <button :disabled="(!props.row.payTotal || props.row.payTotal == null)" class="btn btn__primary btn__small ml-2 mr-2" @click="sendPayment(props.row)">
              Send Payment
              </button> -->
            </span>
            <span v-if="(props.row.paystatus && props.row.paystatus == 'paid')"><button class="btn btn__small btn__flat">Paid<i class="fa-solid fa-check ml-2"></i></button></span>
        </div>
        <div v-else-if="props.row.workerType && props.row.workerType == 'Employees'">
          
           <span v-if="(props.row.employeeId && props.row.employeeOnboardingComplete)">
              <button :disabled="(!props.row.payTotal || props.row.payTotal == null)" class="btn btn__primary btn__small ml-2 mr-2" @click="sendEmployeePayment(props.row)">
              Send Payment
              </button>
            </span>
 
        </div>
      </span>

      <span v-else-if="props.column.field == 'save' && (isPaidAssignments || isPayrollQueue || isUserPayroll)" :class="{ muted: props.row.removed }">
        <div v-if="(!props.row.workerType || props.row.workerType == 'Contractors')">
          <span v-if="(props.row.evereeOnboardingComplete) && (!props.row.paystatus || props.row.paystatus != 'paid')">
            <button :disabled="(!props.row.payTotal || props.row.payTotal == null)" class="btn btn__primary btn__small ml-2 mr-2" @click="sendPayment(props.row)">
            Send Payment
            </button>
          </span>
          <span v-if="(!props.row.evereeOnboardingComplete) && (!props.row.paystatus || props.row.paystatus != 'paid')">
            <button class="btn btn__outlined btn__small ml-2 mr-2" @click="contCheck(props)">
            Sync 
            <span class="ml-2" v-if="!props.row.checking">
              <i class="fa fa-rotate"></i>
            </span>
            <transition name="fade">
              <span class="ml-2" v-if="props.row.checking">
              <i class="fa fa-spinner fa-spin"></i>
              </span>
            </transition>
            </button>
          </span>
          <span v-if="(props.row.paystatus && props.row.paystatus == 'paid')"><button class="btn btn__small btn__flat">Paid<i class="fa-solid fa-check ml-2"></i></button></span>
          <!-- <span v-for="(u, index) in filteredInfo(props.row)" class="flex" :key="index">
            <span v-if="(u.workerId && u.evereeOnboardingComplete && (props.row.paystatus != 'paid'))">
              <button :disabled="(!props.row.payTotal || props.row.payTotal == null)" class="btn btn__primary btn__small ml-2 mr-2" @click="sendPayment(props.row)">
              Send Payment
              </button>
            </span>
            <span v-if="(props.row.paystatus == 'paid')"><button class="btn btn__small btn__flat">Paid<i class="fa-solid fa-check ml-2"></i></button></span>
          </span> -->
        </div>
        <div v-else-if="props.row.workerType && props.row.workerType == 'Employees'">
          <span v-for="(u, index) in filteredInfo(props.row)" class="flex" :key="index">
           <span v-if="(u.employeeId && u.employeeOnboardingComplete && (props.row.paystatus != 'paid'))">
              <button :disabled="(!props.row.payTotal || props.row.payTotal == null)" class="btn btn__primary btn__small ml-2 mr-2" @click="sendEmployeePayment(props.row)">
              Send Payment
              </button>
            </span>
          </span>
          <span v-if="(props.row.paystatus == 'paid')"><button class="btn btn__small btn__flat">Paid<i class="fa-solid fa-check ml-2"></i></button></span>
        </div>
      </span>


       <span v-else :class="{ muted: props.row.removed }">
        {{props.formattedRow[props.column.field]}}
      </span>
    </template>
  </vue-good-table>
  </div>
</template>

<style scoped>
  .vgt-selection-info-row {
    height: 3.28rem;
  }
</style>

<script>
import { mapState } from 'vuex'
import router from '@/router'
import TimesheetNote from '@/components/Timesheets/TimesheetNote.vue'
import ExportService from "@/services/ExportService"
// import firebase from 'firebase/app';
import * as moment from 'moment'
const fb = require('../firebaseConfig.js')

export default {
	props: ['eventAssignments'],
  data: () => ({
    performingRequest: false,
    performingRequest2: false,
    activeItem: null,
    activeDay: '',
    batch: [],
    statuses: ['completed', 'no-show', 'dropped', 'arrived late', 'left early', 'client fired', 'terminated' ],
    paystatuses: ['paid', 'pending', 'scheduled', 'paid tips', 'paid hours', 'not paid' ],
    columns: [
      
      {
        field: 'delete',
        sortable: false,
      },
      {
        label: 'Date',
        field: 'date',
        width: '88px',
      },
      {
        label: 'Pay Status',
        field: 'paystatus',
        width: '152px',
        sortable: false,
      },
      {
        label: 'Event Status',
        field: 'status',
        width: '152px',
        sortable: false,
      },
      {
        field: 'note',
        sortable: false,
      },
      {
        label: 'First',
        field: 'firstName',
        width: '100px',
      },
      {
        label: 'Last',
        field: 'lastName',
        width: '100px',
      },
      {
        label: 'Link',
        field: 'link',
        sortable: false,
      },
      {
        label: 'Shift',
        field: 'position',
        width: '152px',
      },
      
      {
        label: 'Rate',
        field: 'regRate',
        width: '88px',
        sortable: false,
      },
      // {
      //   label: 'Stamp In',
      //   field: 'checkInTimeStamp',
      //   width: '88px',
      //   sortable: false,
      // },
      // {
      //   label: 'Stamp Out',
      //   field: 'checkOutTimeStamp',
      //   width: '88px',
      //   sortable: false,
      // },
      {
        label: 'Time In',
        field: 'inTime',
        width: '100px',
        sortable: false,
      },
      {
        label: 'Time Out',
        field: 'outTime',
        width: '100px',
        sortable: false,
      },
      
      {
        label: 'Total Hours',
        field: 'totalHours',
        width: '88px',
      },
      {
        label: 'Break Time',
        field: 'breakTime',
        width: '88px',
        sortable: false,
      },
      {
        label: 'Reg Hours',
        field: 'regHours',
        width: '88px',
      },
      {
        label: 'Min Hours',
        field: 'minHours',
        width: '88px',
      },
      {
        label: 'OT',
        field: 'otHours',
        width: '88px',
        sortable: false,
      },
      {
        label: '2OT',
        field: 'ot2Hours',
        width: '88px',
        sortable: false,
      },
      {
        label: 'MBP Penalty',
        field: 'mbp',
        width: '88px',
        sortable: false,
      },
      {
        label: 'Tips',
        field: 'tips',
        width: '88px',
      },
      {
        label: 'Bonus',
        field: 'dayRate',
        width: '88px',
        sortable: false,
      },
      {
        label: 'Pay Total',
        field: 'payTotal',
        width: '100px',
        sortable: false,
      },
      {
        label: 'Onboarded',
        field: 'onboardStatus',
        sortable: false,
      },
      {
        label: 'Send Payment',
        field: 'save',
        sortable: false,
      },
    ],
  }),
  computed: {
    ...mapState(['currentUser', 'userProfile']),
  	// visibleAssignments() {
    //   if (this.isUserPayroll) {
    //     return this.eventAssignments
    //   } else {
    //     return this.eventAssignments.filter(item => {
    //       return ((!item.hidden || item.hidden != true) && (!item.paystatus || item.paystatus != 'paid'))
    //     })
    //   }
      
    // },
    isPayrollQueue() {
      return this.$route.name == 'payrollQueue';
    },
    isUserPayroll() {
      return this.$route.name == 'userPayroll';
    },
    isPaidAssignments() {
      return this.$route.name == 'paidAssignments';
    },
    // hiddenAssignments() {
    //   return this.eventAssignments.filter(item => {
    //     return (item.hidden)
    //   })
    // },
    // paidAssignments() {
    //   return this.eventAssignments.filter(item => {
    //     return (item.paystatus == 'paid')
    //   })
    // },
    // totalHours() {
    //   let totalArr = []
    //   this.visibleAssignments.forEach(item => {
    //     if (item.totalHours) {
    //       totalArr.push(Number(item.totalHours))
    //     }
    //   })
    //   if (totalArr.length >= 1) {
    //     // console.log(totalArr)
    //     let result = totalArr.reduce((sum, num) => sum + num);
    //     return result.toFixed(2)
    //   } else {
    //     return 0
    //   }
    // },
    // totalPayroll() {
    //   let totalArr = []
    //   this.visibleAssignments.forEach(item => {
    //     if (item.payTotal) {
    //       totalArr.push(Number(item.payTotal))
    //     }
    //   })
    //   if (totalArr.length >= 1) {
    //     // console.log(totalArr)
    //     let result = totalArr.reduce((sum, num) => sum + num);
    //     return result.toFixed(2)
    //   } else {
    //     return 0
    //   }
    // },
    // totalBilling() {
    //   if (!this.isPayrollQueue && !this.isUserPayroll && (this.eventInfo.venue && this.eventInfo.venue.job && this.visibleAssignments && this.visibleAssignments.length >= 1)) {
    //     let totalArr = []
    //     this.eventInfo.venue.job.forEach(item => {
    //       this.visibleAssignments.forEach(assignment => {
    //         if ((assignment.position == item.title) && assignment.totalHours && item.billRate) {
    //           let total = Number(assignment.totalHours) * item.billRate
    //           totalArr.push(Number(total))
    //         } else {

    //         }
    //       })
    //     })
    //     if (totalArr.length >= 1) {
    //       let result = totalArr.reduce((sum, num) => sum + num);
    //       return result.toFixed(2)
    //     } else {
    //       return 0
    //     }
    //   } else {
    //     return 0
    //   }
    // },
    // totalProfit() {
    //   if (!this.isPayrollQueue) {
    //     return (this.totalBilling - this.totalPayroll).toFixed(2)
    //   } else {
    //     return 0
    //   }
    // },
  },
  components: {
    TimesheetNote
  },
  methods: {
    removeIn(item) {
      this.$store.dispatch('deleteInTimeAssignment', item)
    },
    removeOut(item) {
      this.$store.dispatch('deleteOutTimeAssignment', item)
    },
    showEditIn(row) {
      console.log(row)
      row.showEditIn = true
    },
    showEditOut(row) {
      row.showEditOut = true
    },
    selectionChanged(params) {
      this.batch = params.selectedRows
    },
    // async filteredEmployee(user) {
    //   console.log(user.id)
    //   // const retrieveByExternalId = firebase.functions().httpsCallable('retrieveEmployeeByExternalId')
    //   //   await retrieveByExternalId({
    //   //   id: user.id
    //   // })
    //   // .then(result => {
        
    //   //   return result.data
    //   // })
    // },

    // filteredInfo(user) {
    //   if (this.eventUsersRef) {
    //   return this.eventUsersRef.filter(member => {
    //     if (member && member.id) {
    //       return (member.id == user.userId)
    //     }
    //   })
    //   } else {
    //     return this.user
    //   }
    // },
    formatDate(q) {
      if(q) {
        const postedDate = new Date(q.seconds) * 1000;

        return moment.utc(postedDate).local().format('HH:mm A')
        // return moment(postedDate).format('HH:MM A')
      } else {
        return null
      }
    },
    formatAMPM(date) {
      if (typeof date === "string") {
        let [hours, minutes] = date.split(":");
        let ampm = "AM";

        if (Number(hours) >= 12) {
          hours = Number(hours) - 12;
          ampm = "PM";
        }

        return `${hours}:${minutes} ${ampm}`;

      } else if (date instanceof Date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();

        let ampm = hours >= 12 ? "PM" : "AM";

        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? "0" + minutes : minutes;

        let strTime = hours + ":" + minutes + " " + ampm;

        return strTime;
      }

      return date;
    },
    onUpdatePay(row) {
      fb.assignmentsCollection.doc(row.id).update({
        paystatus: row.paystatus
      })
    },
    onUpdateStatus(row) {
      fb.assignmentsCollection.doc(row.id).update({
        status: row.status
      })
    },
    showNote(r) {
      console.log(r)
      this.activeItem = r
    },
    closeNote(r) {
      this.activeItem = null
    },
    removeEntry(row) {
      console.log(row.id)
      fb.assignmentsCollection.doc(row.id).update({
        hidden:true
      })
    },
    showEntry(row) {
      fb.assignmentsCollection.doc(row.id).update({
        hidden:false
      })
    },
    async contCheck(props) {
      props.row.checking = true
      await this.$store.dispatch('refreshContractorByAssignment', props.row)
    },
    async onEditPosition(row) {
      console.log('updating position')
      await fb.assignmentsCollection.doc(row.id).update({
        regRate: row.position.rate,
        position: row.position.title,
        totalUpdating: true
      })
    },
    async onEditRegRate(row) {
      console.log('updating reg rate')

      await fb.assignmentsCollection.doc(row.id).update({
        regRate: row.regRate,
        totalUpdating: true
      })

    },
    async onEditIn(row) {
      console.log('updating in out')
      await fb.assignmentsCollection.doc(row.id).update({
        inTime: row.inTime,
      })
    },
    async onEditOut(row) {
      console.log('updating in out')
      await fb.assignmentsCollection.doc(row.id).update({
        outTime: row.outTime,
      })
    },
    async onEditTotalHours(row) {
      console.log('editing total hours')
      await fb.assignmentsCollection.doc(row.id).update({
        totalHours: row.totalHours
      })
      this.onEditRegHours(row)
    },
    // async onUpdateTotalHours(row) {
    //   console.log('updating total hours')
    //   console.log(row)
    //   let totalHours 
    //   if (row.checkInTimeStamp && row.checkOutTimeStamp)
    //   totalHours = ((row.outhours + row.outminutes / 60).toFixed(2) - (row.inhours + row.inminutes / 60).toFixed(2))
    //   await fb.assignmentsCollection.doc(row.id).update({
    //     totalHours: row.totalHours
    //   })
    //   this.onEditRegHours(row)
    // },
    async onEditRegHours(row) {
      console.log('updating reg hours')
      if (row.breakTime) {
        let calcHours = (row.totalHours - row.breakTime)
        console.log(calcHours)
        await fb.assignmentsCollection.doc(row.id).update({
          regHours: calcHours,
          totalUpdating: true
        })
        row.regHours = calcHours

      } else {
        await fb.assignmentsCollection.doc(row.id).update({
          regHours: row.totalHours,
          totalUpdating: true
        })
        row.regHours = row.totalHours

      }
    },
    async onManEditRegHours(row) {
      await fb.assignmentsCollection.doc(row.id).update({
        regHours: row.regHours,
        totalUpdating: true
      })
    },
    async onEditMinHours(row) {
      console.log('updating min hours')
      await fb.assignmentsCollection.doc(row.id).update({
        minHours: row.minHours || null,
        totalUpdating: true
      })
    },
    async onEditotHours(row) {
      console.log('updating ot hours')
      if (row.otHours) {
        await fb.assignmentsCollection.doc(row.id).update({
          otHours: row.otHours,
          totalUpdating: true
        })

      } else {
        await null
      }
    },
    async onEditot2Hours(row) {
      console.log('updating 2ot rate')
      if (row.ot2Hours) {
      await fb.assignmentsCollection.doc(row.id).update({
        ot2Hours: row.ot2Hours,
        totalUpdating: true
      })
      } else {
        await null
      }
    },
    async onEditDayRate(row) {
      console.log('updating day rate')
      if (row.dayRate) {
      await fb.assignmentsCollection.doc(row.id).update({
        dayRate: row.dayRate,
        totalUpdating: true
      })
      } else {
        await null
      }
    },
    async onEditBreakTime(row) {
      console.log('updating break')
      if (row.breakTime) {
      await fb.assignmentsCollection.doc(row.id).update({
        breakTime: row.breakTime,
        totalUpdating: true
      })
      // this.onEditRegHours(row)
      } else {
        await null
      }
    },
    async onEditMBP(row) {
      console.log('updating mbp')
      if (row.mbp) {
      await fb.assignmentsCollection.doc(row.id).update({
        mbp: row.mbp,
        totalUpdating: true
      })
      } else {
        await null
      }
    },
    async onEditTips(row) {
      console.log('updating tips')
      if (row.tips) {
      await fb.assignmentsCollection.doc(row.id).update({
        tips: row.tips,
        totalUpdating: true
      })
      } else {
        await null
      }
    },
    async onUpdateTotal(row) {
      await this.$store.dispatch('updateAssignmentTotal', row)
      // fb.assignmentsCollection.doc(row.id).update({
      //   totalUpdating: true
      // })
      // console.log('editing total')
      // console.log(row)
      // let hours
      // if (row.minHours > row.regHours) {
      //   hours = row.minHours
      // } else {
      //   hours = row.regHours
      // }

      // if (row.regHours && row.regRate) {

      // let total = (hours * row.regRate) + 
      // (parseFloat((row.otHours || 0) * (row.regRate * 1.5))) + 
      // (parseFloat((row.ot2Hours || 0) * ((row.regRate || 0) * 2))) + 
      // (parseFloat((row.mbp || 0) * row.regRate)) + 
      // (parseFloat(row.tips || 0)) + 
      // (parseFloat(row.dayRate || 0))
      // console.log(total)
      // await fb.assignmentsCollection.doc(row.id).update({
      //   payTotal: total.toFixed(2),
      //   totalUpdating: false
      //   // regHours: row.regHours

      // })
      // } else {
      //   await fb.assignmentsCollection.doc(row.id).update({
      //     payTotal: 0,
      //     totalUpdating: false
      //   })
      // }
    },
    exportReport() {
      this.performingRequest2 = true
      const exportHeaders = [
        "Date",
        "First Name",
        "Last Name",
        "Position",
        "Hourly Rate",
        "Clock-In",
        "Clock-Out",
        "Total Hours",
        "Break",
        "Reg Hours",
        "Minimum Hours",
        "Billable Hours",
        "Overtime",
        "2x Overtime",
        "Break Penalty",
        "CC Tips"
      ];
      const exportItems = [];
      for (var key in this.batch) {
        if (!this.batch[key].hidden) {


          let billHours
          if (this.batch[key].minHours > this.batch[key].regHours) {
            billHours = this.batch[key].minHours
          } else {
            billHours = this.batch[key].regHours
          } 

          // let inTime = (this.formatDate(this.batch[key].checkInTimeStamp) || this.batch[key].inTime)
          // let outTime = (this.formatDate(this.batch[key].checkOutTimeStamp) || this.batch[key].outTime)

          exportItems.push([
            this.batch[key].date,
            this.batch[key].firstName,
            this.batch[key].lastName,
            this.batch[key].position,
            this.batch[key].regRate,
            this.batch[key].inTime,
            this.batch[key].outTime,
            this.batch[key].totalHours,
            this.batch[key].breakTime,
            this.batch[key].regHours,
            this.batch[key].minHours,
            billHours,
            this.batch[key].otHours,
            this.batch[key].ot2Hours,
            this.batch[key].mbp,
            this.batch[key].tips
          ]);
        }
      }
      this.$gapi.getGapiClient().then(gapi => {
        const exportService = new ExportService(exportHeaders, Object.values(exportItems), gapi);
        exportService.export();
      });
      setTimeout(() => {
        this.performingRequest2 = false
      }, 2000)
    },
    async payBatch() {
      this.performingRequest = true
      let payArray = []
      this.batch.forEach(item => {

        let payNote = item.day + ' / ' + item.regHours || `0` + '/' + item.otHours || `0` + '/' + item.ot2Hours || `0` + ' hours'
        // let payNote = item.day + item.
        let total = {
          amount: item.payTotal
        }
        let newItem = {
          amount: total,
          taxCalcMethod: 'OPTIMIZED',
          externalWorkerId: item.userId,
          note: payNote,
          type: item.eventInfo.workerType || null,
          title: item.eventName || 'Jump Payment',
          message: item.id
        }
        payArray.push(newItem)
      })
      console.log(payArray)
      let workerType = payArray[0].type
      let payTitle = payArray[0].title
      await this.$store.dispatch('createBatchPayment', {
        type: workerType,
        users: payArray,
        title: payTitle,
      })
      // if (this.eventInfo && this.eventInfo.workerType == 'Employees') {
      //   sendUserPayment = firebase.functions().httpsCallable('createBatchEmployeePayments')
      // } else {
      //   sendUserPayment = firebase.functions().httpsCallable('createBatchPayments')
      // }
      // await sendUserPayment(payArray)
      // .then(result => {
      //   if (result && result.data) {
      //     console.log(result.data)
      //     this.performingRequest = false
      //   }
      // })
    },
    async newPayable(row) {
      console.log(row)
      let payNote = row.day + ' / ' + row.regHours || `0` + '/' + row.otHours || `0` + '/' + row.ot2Hours || `0` + ' hours'
      // let payNote = row.name + ' / ' + row.day
      await this.$store.dispatch('createNewPayable', {
        amount: row.payTotal,
        workerId: row.realId || row.userId,
        note: payNote,
        assignmentId: row.id,
        title: row.eventName || 'Jump Payment',
        type: row.eventInfo.workerType || 'Contractors',
      })
      .then(result => {
        if (result && result.data) {
          console.log(result.data)
        }
      })
    },
    async sendPayment(row) {
      console.log(row)
      let payNote = row.day + ' / ' + row.regHours || `0` + '/' + row.otHours || `0` + '/' + row.ot2Hours || `0` + ' hours'
      // let payNote = row.name + ' / ' + row.day
      await this.$store.dispatch('createUserPayment', {
        amount: row.payTotal,
        id: row.realId || row.userId,
        note: payNote,
        assignmentId: row.id,
        title: row.eventName || 'Jump Payment'
      })
      .then(result => {
        if (result && result.data) {
          console.log(result.data)
        }
      })
    },
    async sendEmployeePayment(row) {
      console.log(row)
      await this.$store.dispatch('createEmployeePayment', {
        amount: row.payTotal,
        id: row.realId || row.userId,
        note: row.name + ' / ' + row.day,
        assignmentId: row.id
      })
      // .then(result => {
      //   if (result && result.data) {
      //     console.log(result.data)
      //   }
      // })
    },
    // onSheetEditable(row)  {
    //   row.editable = true
    // },
    // onSheetEdit(row) {
    //   row = row
    //   row.editable = false
    //   this.$store.dispatch('updateTimesheet', row)
    // },
  },
  beforeDestroy () {
    this.columns = null
    delete this.columns
    this.activeItem = null
    delete this.activeItem
    this.activeDay = null
    delete this.activeDay
    this.batch = null
    delete this.batch
    this.statuses = null
    delete this.statuses
    this.paystatuses = null
    delete this.paystatuses
    delete this.onSheetEdit
    delete this.onSheetEditable
    delete this.sendEmployeePayment
    delete this.sendPayment
    delete this.payBatch
    delete this.onUpdateTotal
    delete this.onEditTips
    delete this.onEditMBP
    delete this.onEditBreakTime
    delete this.onEditDayRate
    delete this.onEditot2Hours
    delete this.onEditotHours
    delete this.onEditMinHours
    delete this.onManEditRegHours
    // delete this.onEditRegHours
    delete this.onEditTotalHours
    delete this.onEditIn
    delete this.onEditOut
    delete this.onEditRegRate
    delete this.onEditPosition
    delete this.showEntry
    delete this.removeEntry
    delete this.showNote
    delete this.closeNote
    delete this.onUpdateStatus
    delete this.onUpdatePay
    delete this.formatAMPM
    delete this.formatDate
    delete this.filteredInfo
    // delete this.filteredEmployee
    delete this.selectionChanged
    delete this.showEditIn
    delete this.showEditOut
    delete this.removeIn
    delete this.removeOut
  }
}
</script>